
// FIX: The original file was truncated, causing a missing default export error.
// The file has been completed with the expected list of notifications, an empty state, and the required default export.
import React from 'react';
import type { Notification } from '../../types';
import NotificationItem from './NotificationItem';
import { Icons } from '../ui/Icons';

interface NotificationPanelProps {
    notifications: Notification[];
    onMarkAsRead: (id: string) => void;
    onMarkAllAsRead: () => void;
    onClearAll: () => void;
    onClose: () => void;
}

const NotificationPanel: React.FC<NotificationPanelProps> = ({ notifications, onMarkAsRead, onMarkAllAsRead, onClearAll, onClose }) => {
    const hasUnread = notifications.some(n => !n.read);
    const displayedNotifications = notifications.slice(0, 50);

    return (
        <div className="absolute top-full right-0 mt-2 w-80 sm:w-96 bg-white dark:bg-slate-800 rounded-lg shadow-2xl border border-gray-200 dark:border-slate-700 z-50 overflow-hidden">
            <div className="flex justify-between items-center p-3 border-b border-gray-200 dark:border-slate-700">
                <div className="flex items-center gap-2">
                    <h3 className="font-semibold text-gray-800 dark:text-gray-200">Notifications</h3>
                    <span className="text-[10px] px-1.5 py-0.5 bg-gray-100 dark:bg-slate-700 text-gray-500 rounded-full font-bold">
                        {notifications.length}
                    </span>
                </div>
                <div className="flex gap-3">
                    {hasUnread && (
                        <button
                            onClick={onMarkAllAsRead}
                            className="text-xs font-medium text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300"
                        >
                            Mark all read
                        </button>
                    )}
                    {notifications.length > 0 && (
                        <button
                            onClick={onClearAll}
                            className="text-xs font-medium text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300"
                        >
                            Clear all
                        </button>
                    )}
                </div>
            </div>
            {notifications.length > 0 ? (
                <ul className="max-h-96 overflow-y-auto divide-y divide-gray-100 dark:divide-slate-700">
                    {displayedNotifications.map(n => (
                        <NotificationItem key={n.id} notification={n} onMarkAsRead={onMarkAsRead} />
                    ))}
                    {notifications.length > 50 && (
                        <li className="p-3 text-center text-xs text-gray-500 bg-gray-50 dark:bg-slate-900/50">
                            Showing latest 50 of {notifications.length} notifications
                        </li>
                    )}
                </ul>
            ) : (
                 <div className="text-center p-8">
                    <Icons.Bell className="mx-auto h-12 w-12 text-gray-300 dark:text-slate-600" />
                    <h3 className="mt-2 text-sm font-medium text-gray-800 dark:text-gray-300">All caught up!</h3>
                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">You have no new notifications.</p>
                </div>
            )}
        </div>
    );
};

export default NotificationPanel;